import { Avatar } from '@material-ui/core';
import styled from 'styled-components';
import { DEVICE } from '../../GlobalStyle';

export const Container = styled.div<{backgroundColor: string, showChat: boolean, isExpanded: boolean, forceResponsiveMode: boolean, icon: boolean, isMobile: boolean}>`
  height: 50px;
  width: 100%;
  background-color: ${props => (props.icon && (props.forceResponsiveMode || props.isMobile) && !props.showChat) ? 'transparent' : props.backgroundColor};
  border-radius: ${props => props.isExpanded ? '0' : ` 7px 7px 0 0`};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  user-select:none;
  cursor: ${props => props.showChat ? 'auto' : 'pointer'};

  @media ${DEVICE.mobile} {
    height: ${props => props.showChat ? 50 : 65}px;
    border-radius: 0;
  }

  ${props => props.forceResponsiveMode ? `@media all {
    height: ${props.showChat ? 50 : 65}px;
    border-radius: ${props.isExpanded || props.isMobile ? '0' : ` 7px 7px 0 0`};
  }`: ``}
`;

export const Title = styled.span<{showChat: boolean, forceResponsiveMode: boolean}>`
  flex: 1;
  font-size: 14px;
  margin-left: 14px;
  margin-right: 14px;

  @media ${DEVICE.mobile} {
    display: ${props => props.showChat ? 'block' : 'none'};
  }

  ${props => props.forceResponsiveMode ? `@media all {
    display: ${props.showChat ? 'block' : 'none'};
  }`: ``}
`;

export const IconWrapper = styled.span<{showChat: boolean, forceResponsiveMode: boolean}>`
  display: flex;
  margin-left: 14px;
  align-items: center;
  cursor: pointer;
  
  span {
    font-size: 16px;
  }

  ${props => props.forceResponsiveMode && !props.showChat? `@media all {
    display: block;
      margin: 0 auto;
  
      span {
        font-size: 30px;
      }
  }`: ``}

  ${props => !props.showChat ? 
    `
    @media ${DEVICE.mobile} {
      display: block;
      margin: 0 auto;
  
      span {
        font-size: 30px;
      }
    }
    `
    :
    ``
  }
  
`;

export const Content = styled.div<{color: string}>`
  color: ${props => props.color};
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ExpandWrapper = styled.span`
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-left: 14px;
  margin-right: 14px;

  @media ${DEVICE.mobile} {
    display: none;
  }
`;

export const StyledAvatar = styled(Avatar)<{textColor?: string, backgroundColor?: string}>`
  && {
    width: 65px;
    height: 65px;
    margin: auto;
    color: ${props => props.textColor};
    background-color: ${props => props.backgroundColor};
  }
`;
